import styled from "styled-components"

export interface StyledBookingsProps {
  background_color?: string
  text_color?: string
}

export const StyledTrigger = styled.div`
  background: blue;
  right: 64px;
  bottom: 64px;
  position: fixed;
  z-index: 99999;
  width: 80px;
  height: 80px;
  max-width: 80px;
  max-height: 80px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.2);

  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    right: 24px;
    bottom: 24px;
    width: 60px;
    height: 60px;
    max-width: 60px;
    max-height: 60px;
    border-radius: 30px;
  }

  & svg {
    color: white;
  }
`

export const StyledBookings = styled.div<StyledBookingsProps>`
  position: fixed;
  background: ${(props) => props.background_color || '#e2effd'};
  z-index: 9999999;
  bottom: 168px;
  right: 64px;
  max-width: 460px;
  min-width: 460px;
  border-radius: 24px;
  padding: 24px;
  display: grid;
  gap: 8px;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.2);

  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    bottom: 24px;
    right: 24px;
    left: 24px;
    width: calc(100% - 48px);
    max-width: calc(100% - 48px);
    min-width: calc(100% - 48px);
    border-radius: 24px;
    padding: 24px;
    overflow: hidden;
  }

  &:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 16px solid ${(props) => props.background_color || '#e2effd'};
    position: absolute;
    top: 100%;
    right: 40px;
    transform: translateX(50%);

    @media (max-width: ${props => props.theme.breakPoints.tablet}) {
      display: none;
    }
  }
`
export const StyledBookingsClose = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
  z-index: 1;
`
export const StyledBookingsIcon = styled.img`
  max-height: 42px;

  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    max-height: 32px;
  }
`
export const StyledBookingsImage = styled.img`
  width: 100%;
  max-width: 75%;
  margin: 0 auto 8px;

  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    position: absolute;
    bottom: -24px;
    right: 0;
    transform: translateX(50%);
    margin: 0;
  }
`
export const StyledBookingsTitle = styled.h3<StyledBookingsProps>`
  margin: 0;
  position: relative;
  color: ${(props) => props.text_color || "#2b2b2b"};
`
export const StyledBookingsCopy = styled.div<StyledBookingsProps>`
  margin: 0;
  position: relative;

  & p {
    color: ${(props) => props.text_color || props.theme.colors.darkGrey80};
  }
`
export const StyledBookingsLinks = styled.div<StyledBookingsProps>`
  margin: 8px 0 0;
  position: relative;
  display: flex;
  gap: 16px;
  align-items: center;

  @media (max-width: ${props => props.theme.breakPoints.tablet}) {
    flex-direction: column;
    align-items: flex-start;
  }

  & a {
    color: ${(props) => props.text_color || props.theme.colors.darkGrey};
    text-decoration: underline;
  }
`
